module.exports = __webpack_public_path__ + "static/media/3.4a85fde3.jpg";